import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chart",
  "use": "icon-chart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chart\"><defs><style></style></defs><path d=\"M64 448h256v512H64V448zm640-192h256v704H704V256zM384 64h256v896H384V64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol